import {useCallback, useState} from 'react';

export default function Toggle({defaultValue, children}) {
    const [isToggle, setToggle] = useState(defaultValue);

    const isEventLike = (v) =>
        v !== null &&
        typeof v === 'object' &&
        (typeof v.preventDefault === 'function' || 'nativeEvent' in v || 'target' in v);

    const toggle = useCallback((value) => {
        if (typeof value === 'function') {
            setToggle(value);               // functional update: toggle(prev => !prev)
        } else if (value !== undefined && !isEventLike(value)) {
            setToggle(!!value);             // set giá trị cụ thể: toggle(true) / toggle(false)
        } else {
            setToggle(prev => !prev);       // gọi trơn: toggle() hoặc onClick={toggle}
        }
    }, []);

    return children(isToggle, toggle, setToggle);
}